import { FunctionComponent, useState } from "react";
import { DataList, DataListColumn, StatusBadge, MoneyValue } from "../ui";

const ReceiptsBlocked: FunctionComponent = () => {

    const [bloqueados] = useState<any[]>([]);

    const columns: DataListColumn<any>[] = [
        { key: "numero",       header: "Numero",       render: (n) => n.numero, mono: true },
        { key: "data",         header: "Data",         render: (n) => <span style={{ opacity: .55 }}>{n.data}</span>, mono: true },
        { key: "valor",        header: "Valor",        render: (n) => <MoneyValue amount={n.valor} tone="neutral" />, align: "right" },
        { key: "destinatario", header: "Destinatario", render: (n) => n.destinatario },
        { key: "motivo",       header: "Motivo",       render: (n) => <span style={{ color: "var(--c-warn)" }}>{n.motivo}</span> },
        { key: "status",       header: "Status",       render: () => <StatusBadge status="blocked" tone="danger" label="Bloqueado" /> },
    ];

    return (
        <div className="tab-bloqueados">
            <DataList
                columns={columns}
                rows={bloqueados}
                empty="Nenhuma nota bloqueada."
            />
        </div>
    );
};

export default ReceiptsBlocked;
